import Vue from 'vue'

import VueMoment from 'vue-moment'
import Moment from 'moment-timezone' // Import moment-timezone here
import 'moment/locale/de'
import 'moment/locale/es'
import 'moment/locale/pt'
import 'moment/locale/fr'
import 'moment/locale/he'
import i18n from './i18n'

Moment.tz.setDefault(Moment.tz.guess())

Moment.server = function (value, format, utc) {
  if (utc !== false) {
    return Moment
      .utc(value, format)
      .local()
  } else {
    return Moment(value, format)
  }

}

Moment.serverDate = function (value, utc) {
  if (utc !== false) {
    return Moment
      .utc(value, 'YYYY-MM-DD')
      .local()
  } else {
    return Moment(value, 'YYYY-MM-DD')
  }

}

Moment.serverDateTime = function (value, utc) {
  if (utc !== false) {
    return Moment
      .utc(value, 'YYYY-MM-DD HH:mm')
      .local()
  } else {
    return Moment(value, 'YYYY-MM-DD HH:mm')
  }
}

Moment.prototype.toServerDateFormat = function () {
  return this.format('YYYY-MM-DD')
}

Moment.prototype.toServerDateTimeFormat = function () {
  return this.format('YYYY-MM-DD HH:mm')
}

Moment.prototype.toServerTimeFormat = function () {
  return this.format('HH:mm')
}

Vue.use(VueMoment, { moment: Moment })
Vue.filter('moment', function (value, format, utc) {
  if (value === null || value === undefined || format === undefined) {
    return ''
  }
  if(utc === undefined){
    utc = true
  }
  if (format === 'from') {
    return (utc ? Moment.utc(value) : Moment(value))
      .local()
      .fromNow()
  }
  if (format === 'diff') {
    return Moment()
      .diff((utc ? Moment.utc(value) : Moment(value))
        .local(), 'minutes')
  }
  return (utc ? Moment.utc(value) : Moment(value))
    .local()
    .format(format)
})

Vue.filter('momentDate', function (value) {
  if (value == null) {
    return ''
  }
  return Moment
    .utc(value, 'YYYY-MM-DD')
    .local()
    .format(i18n.t('timeFormat.date.format'))
})

Vue.filter('momentDateTime', function (value) {
  if (value == null) {
    return ''
  }
  return Moment
    .utc(value, 'YYYY-MM-DD HH:mm')
    .local()
    .format(i18n.t('timeFormat.dateTime.format'))
})

// Same as momentDateTime but keeps the SECONDS (e.g. trade open/close times).
Vue.filter('momentDateTimeSeconds', function (value) {
  if (value == null) {
    return ''
  }
  const base = i18n.t('timeFormat.dateTime.format') || 'DD/MM/YYYY HH:mm'
  const fmt = base.indexOf('ss') >= 0 ? base : base.replace('HH:mm', 'HH:mm:ss')
  return Moment
    .utc(value, ['YYYY-MM-DD HH:mm:ss', 'YYYY-MM-DD HH:mm', Moment.ISO_8601])
    .local()
    .format(fmt)
})

export default Moment;